export default "__VITE_ASSET__ab2584a4__"